import { useInit } from '~hooks/use-init';

export function useSettings() {
    const { data } = useInit();

    return data;
}
